import {PaginationQuery} from "helpers/interfaces/Pagination";

const DEFAULT_PAGINATION: PaginationQuery = {
  page: 1,
  perPage: 10
};

const INITIAL_PAGINATION = {
  total: 0,
  perPage: 10,
  totalPages: 0,
  page: 1
};

export {
  DEFAULT_PAGINATION,
  INITIAL_PAGINATION
};
